// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

function requireAll(r) {
  r.keys().forEach(r);
}

requireAll(require.context("modules", true, /\.js$/));
